import { createApp } from 'vue'
import App from './App.vue'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import router from './router' // 引入路由文件


const vuetify = createVuetify({
    components,
    directives
})

const app = createApp(App)
app.use(VXETable);
app.use(vuetify)
app.use(router)
app.mount('#app')

